import Icon from 'src/components/atoms/icon'

import { useMenuStore } from 'src/stores'

function MenuCollapseButton() {
  const [collapsed, setMenuState] = useMenuStore((state) => [
    state.collapsed,
    state.setMenuState,
  ])

  return (
    <button
      onClick={setMenuState}
      data-testid="menu-collapse-btn"
      className="absolute right-[-14px] top-[50%] z-10 flex h-7 w-4 items-center justify-center rounded-r-full bg-bg-base shadow-lg"
    >
      {collapsed ? (
        <Icon name="ChevronRight" className="mr-1 min-w-[15px] text-contrast" />
      ) : (
        <Icon name="ChevronLeft" className="mr-1 min-w-[15px] text-contrast" />
      )}
    </button>
  )
}

export default MenuCollapseButton
